import SEO from '../../components/seo/SEO'
import { breadcrumb } from '../../components/seo/jsonLd'

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How Salon Vora collects, uses and protects your personal data when you book, browse or contact us."
        path="/privacy-policy"
        jsonLd={breadcrumb([{ name: 'Home', url: '/' }, { name: 'Privacy Policy', url: '/privacy-policy' }])}
      />

      <article className="bg-white">
        <header className="bg-hero-gradient py-24 text-center">
          <div className="container-salon">
            <span className="section-tag !text-salon-secondary !bg-salon-secondary/15">Legal</span>
            <h1 className="font-display text-4xl md:text-5xl text-white font-bold mt-3">Privacy Policy</h1>
            <p className="text-white/70 font-body mt-3">Last updated: January 2026</p>
          </div>
        </header>

        <div className="container-salon max-w-3xl py-16 prose-salon">
          <Section title="1. Who we are">
            Salon Vora (“we”, “us”, “our”) operates the website salonvora.com and provides salon and beauty services in Chennai, India.
          </Section>

          <Section title="2. Information we collect">
            We collect information you give us when booking an appointment, registering an account, contacting us, or using our services. This includes your name, phone number, email, address (for on-location services), payment details and booking history.
          </Section>

          <Section title="3. How we use your information">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>To confirm, modify and remind you of appointments</li>
              <li>To process payments and issue invoices</li>
              <li>To respond to enquiries and feedback</li>
              <li>To send promotional offers (only if you opt in)</li>
              <li>To improve our services and website</li>
            </ul>
          </Section>

          <Section title="4. Sharing your information">
            We never sell your personal data. We share it only with trusted processors (payment gateways, SMS/email providers) under strict data agreements, or when required by law.
          </Section>

          <Section title="5. Data retention">
            We retain personal data only as long as needed to provide our services and meet legal/tax obligations. You can request deletion at any time by emailing privacy@salonvora.com.
          </Section>

          <Section title="6. Your rights">
            You have the right to access, correct, port and delete your personal data. To exercise these rights, please email privacy@salonvora.com from the email address associated with your account.
          </Section>

          <Section title="7. Cookies">
            We use essential cookies to keep you signed in and analytics cookies to understand site usage. You can disable non-essential cookies through your browser settings.
          </Section>

          <Section title="8. Contact">
            For any privacy-related questions: <a href="mailto:privacy@salonvora.com" className="text-salon-primary underline">privacy@salonvora.com</a>.
          </Section>
        </div>
      </article>
    </>
  )
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-2xl font-semibold text-salon-dark mb-3">{title}</h2>
      <div className="text-salon-muted font-body leading-relaxed">{children}</div>
    </section>
  )
}
